<template>
  <v-dialog
    :value="isVisible"
    :max-width="maxWidth"
    :width="width"
    @click:outside="closeModal">
    <v-card v-if="component">
      <component
        :is="component"
        v-bind="parameters"
        @close="closeModal"/>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  data() {
    return {
      defaultMaxWidth: 1200,
      defaultWidth: 500
    };
  },
  computed: {
    ...mapGetters(['isVisible', 'component', 'parameters']),
    maxWidth() {
      return this?.parameters?.maxWidth || this?.defaultMaxWidth;
    },
    width() {
      return this?.parameters?.width || this?.defaultWidth;
    }
  },
  methods: {
    ...mapActions(['closeModal']),
  }
};
</script>
